import {
    Component,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";

export interface OverlayControl {
    closeOverlay(): void;

    openOverlay(): void;

    toggleOverlay(): void;
}

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: "deloitteai-overlay",
    styles: [
        `
      .ai-overlay {
        position: absolute;
        z-index: 5000;
      }
    `,
    ],
    template: `
    <ng-template #wrapper>
      <ng-content></ng-content>
    </ng-template>
  `,
})
export class AIOverlayComponent {
    @ViewChild("wrapper", { read: TemplateRef, static: true })
    public template: TemplateRef<void>;

    /**
     * the overlay control
     *
     */
    control: OverlayControl;

    /**
     * close the overlay
     *
     */
    closeOverlay(): void {
        this.control.closeOverlay();
    }

    /**
     *
     * open the overlay
     *
     */
    openOverlay(): void {
        this.control.openOverlay();
    }

    /**
     * toggle the overlay
     *
     */
    toggleOverlay(): void {
        this.control.toggleOverlay();
    }
}
